<template>
  <div class="mm-row-block">
    <el-form label-width="120px" label-position="left">
      <div class="form-isheader-group">
        <div class="form-isheader-group-content">
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="收款人賬號" required>
                <el-input :disabled="readonly"  v-model="form.account_num_format" @input="cardformat()" @change="cardformat" ref="cardInput" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="收款人名稱" required>
                <el-input :disabled="readonly" v-model="form.account_name" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="收款人電話" >
                <el-input :disabled="readonly" v-model="form.phone" clearable></el-input>
              </el-form-item>
            </div>
          </div>

          <!-- <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="身份證或護照" prop="card">
                <el-input :disabled="readonly" v-model="form.id_card"></el-input>
              </el-form-item>
            </div>
          </div> -->
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="銀行名稱" required>
                <hkbankselect :disabled="readonly" :form="form"></hkbankselect>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="收款人地址" required>
                <el-input :disabled="readonly" v-model="form.address"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="銀行備註">
                <el-input :disabled="readonly" v-model="form.remark"></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>

    </el-form>
  </div>

</template>

<script>
import hkbankselect from './HKBankSelect.vue'
export default {
  components: {
    hkbankselect,
  },
  props: {
    data: {
      type: Object,
      default: () => { },
    },
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  name: "bankinfo",
  data () {
    return {
      form: {
        address: "", // 地址
        phone: "", // 電話
        id_card: "", // 身份証
        account_num_format:"",// 格式化賬號
        account_num: "",// 賬號
        account_name: "", // 持卡人
        province_id: "", // 省份
        city_id: "", // 城市
        country_id: 0,
        countryname: '',
        branch_id: "", // 支行名稱
        branch_name: "", // 支行名稱自定義
        hkbank_id: 0,
        cnbank_id: 0,
        bankname: "",
        hkbankname: "",
        currency_id: "", // 貨幣id
        swift_code: "", // swift_code
        address: "", // 收款人地址
        remark: "", // 銀行備註
      }
    }
  },
  methods: {
    cardformat () {
      let val = this.form.account_num_format;
      this.formatCardNumber(this.form, val);
    },
  },
  created () {
    // 过滤表格配置传递的参数，如果存在则替换默认值，否则按默认值显示
    for (let key in this.data) {
      if (this.form.hasOwnProperty(key)) { //把默认配置中的配置项进行替换
        this.form[key] = this.data[key];
      }
    }
  },
  watch: {
    'form.account_num_format' (val) {
      if (val) {
        this.form.account_num = this.mytrim(val);
      }else{
        this.form.account_num = '';
      }
    },
    form: {
      deep: true,
      handler: function (newVal, oldVal) {
        this.$emit('update:data', newVal);
      }
    }
  }
}
</script>

<style scoped>
.flex50 {
  flex: 0 50%;
}
.flex-start {
  justify-content: start;
}
</style>
